export default {
      id: "heart-negative-usage",
      viewBox: "0 -28 512.00002 512",
      url: "/assets/svg/" + "sprite.svg#heart-negative-usage",
      toString: function () {
        return this.url;
      }
    }